import {environment} from '../../environments/environment';
export class Shared {
  public static TransmitterApiBaseUrl: string = environment.TransmitterApiBaseUrl;
  public static baseUrl:string = environment.BaseUrl;
  public static ClientSideUrl:string = environment.clientSideBaseUrl;
  public static SearchResulsSourceParamValue:string = "SearchResults";
  public static MatchedJobsToJobResultsSource:string = "MatchedJobsToJobResults";
  public static MatchedJobsToCvResultsSource:string = "MatchedJobsToCvResults";
  public static MatchedCvsToJobResultsSource:string = "MatchedCvsToJobResults";
  public static MatchedCvsToCvResultsSource:string = "MatchedCvsToCvResults";
  public static ShortlistResultsSourceParamValue:string = "ShortlistResults";
  
  public static ClientSideUrlWithoutSlash:string = environment.HostName;
  public static StageUrl:string = "http://stage-web.apply4u.co.uk/";
 // public static StageUrl:string = "https://elastic.apply4u.co.uk/";
  public static LocalHostUrl:string ="http://localhost:4200/";

  public static JobSeeker:number = 1;//1 is job Seeker
  public static Recruiter:number = 2; //2 is Recruiter
  public static Networker:number = 3; //3 is Networker
}

export const LiveHostName = environment.HostName;
